import React from "react";
import subscriptionPlans from "img/screenshots/subscription_plans.png";

export default function InvoiceSubscriptionPlans() {
  return (
    <div className="StartGuidePlans StartGuidePlans--shot" aria-hidden="true">
      <img src={subscriptionPlans} alt="" />
    </div>
  );
}
